import React from 'react';
import { useSelector } from 'react-redux';
import { selectCompany } from '../../../store/slices/InitialDataSlice';
import useNavigate from '../../../hooks/navigation/useNavigate';
import { SCREENS } from '../../../services/exports/Constants';
import De from './De';
import { useTranslation } from 'react-i18next';
import En from './En';
import { StoreInterface } from '../../../store/types';

export type Props = {
  companyLegalName: string;
  companyAddress: string;
  companyLegalEmail: string;
  companyLegalWebsite: string;
  companyLegalBusinessName: string;
  companyLegalPrivacyUrl: string;
  agbVersionDate: string;
  companyLegalCity: string;
  companyCountryName: string;
  currencyName: string;
};

const GiftCardTermsAndConditions = () => {
  const company = useSelector(selectCompany);
  const companyLegalBusinessName = useSelector((state: StoreInterface) => state.initialData?.franchise?.name);
  const { generatePath } = useNavigate();
  const { i18n } = useTranslation();
  const companyLegalWebsite = window.location.origin;
  const companyLegalPrivacyUrl = String(companyLegalWebsite).concat(generatePath(SCREENS.PRIVACY_POLICY));
  const companyLegalName = company?.name;
  const companyLegalCity = company?.city;
  const agbVersionDate = new Date().toLocaleDateString();
  const companyLegalEmail = company?.email;
  const companyAddress = company?.legal_address;
  const displayName = (type: 'region' | 'currency', code?: string | null): string => {
    if (!code) {
      return '';
    }

    try {
      return new Intl.DisplayNames([i18n.language], { type }).of(code) ?? code;
    } catch {
      return code;
    }
  };

  const companyCountryName = displayName('region', company?.country);
  const currencyName = displayName('currency', company?.currency);
  const props: Props = {
    companyLegalWebsite,
    companyLegalBusinessName,
    companyLegalName,
    companyLegalCity,
    agbVersionDate,
    companyLegalEmail,
    companyAddress,
    companyLegalPrivacyUrl,
    companyCountryName,
    currencyName,
  };

  // Only a German bundle exists besides English, so every other UI language reads the English terms.
  if (i18n.language === 'de') {
    return <De {...props} />;
  }

  return <En {...props} />;
};

export default GiftCardTermsAndConditions;
